import { APP_INITIALIZER, ErrorHandler, enableProdMode, importProvidersFrom } from '@angular/core'

import { HashLocationStrategy, LocationStrategy } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import { UrlSerializer, provideRouter } from '@angular/router'
import { ConfirmationService, MessageService } from 'primeng/api'
import { AppRoutingModule } from './app/app-routing.module'
import { AppComponent } from './app/app.component'
import { LowerCaseUrlSerializer } from './app/app.module'
import { CoreModule } from './app/core/core.module'
import { ClientErrorHandler } from './app/core/interceptors/client-error.interceptor'
import { MenuService } from './app/layout/services/menu.service'
import { AppConfigService } from './app/shared/services/app-config.service'
import { ThemeService } from './app/shared/services/app-theme.service'
import { CurrentUserService } from './app/shared/services/current-user.service'
import { MessageBusService } from './app/shared/services/message-bus.service'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(CoreModule, BrowserModule, AppRoutingModule),
    { provide: ErrorHandler, useClass: ClientErrorHandler },
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfiguration()
        }
      },
    },
    ThemeService,
    MessageService,
    MessageBusService,
    CurrentUserService,
    ConfirmationService,
    MenuService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter([]),
  ],
}).catch((err) => console.error(err))
